module.exports = __webpack_public_path__ + "static/img/doc.95bbe148.png";